
export default function LocationSection() {
  return (
    <section id="location" className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">地理位置</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
            位於沖繩石垣市真榮里地區，享有得天獨厚的地理優勢和便利的交通網絡。
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
          <div className="space-y-8">
            <div>
              <h3 className="text-3xl font-bold text-gray-900 mb-6">優越位置優勢</h3>
              <div className="space-y-6">
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-plane-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">石垣機場</h4>
                    <p className="text-gray-600">距離僅10分鐘車程，便利的航空交通</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-building-2-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">市中心</h4>
                    <p className="text-gray-600">5-10分鐘即可到達石垣市中心商業區</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-ship-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">離島碼頭及新港</h4>
                    <p className="text-gray-600">輕鬆前往竹富島、西表島等周邊島嶼；未來「八重山丸號」加強台灣交通便利性，打造第二生活圈</p>
                  </div>
                </div>
                <div className="flex items-start space-x-4">
                  <div className="w-12 h-12 bg-teal-600 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-landscape-line text-white text-lg"></i>
                  </div>
                  <div>
                    <h4 className="text-lg font-semibold text-gray-900 mb-2">自然景觀</h4>
                    <p className="text-gray-600">鄰近美麗海灘和熱帶自然保護區，擁有世界級潟湖、珊瑚礁與星空保護區</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <img 
              src="https://public.readdy.ai/ai/img_res/d5b7c3a5d2b27ecb5045d98dbea33ed4.jpg"
              alt="石垣島航拍圖"
              className="w-full h-auto rounded-lg shadow-lg object-cover"
            />
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">項目位置地圖</h3>
          <div className="w-full h-96 rounded-lg overflow-hidden">
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m14!1m12!1m3!1d454.405294438371!2d124.18404737372357!3d24.338049040882986!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!5e0!3m2!1szh-TW!2stw!4v1760340852074!5m2!1szh-TW!2stw"
              width="100%"
              height="100%"
              style={{ border: 0 }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="石垣市真榮里宮鳥開發計畫位置"
            ></iframe>
          </div>
          <div className="mt-6 text-center">
            <p className="text-gray-600">
              <i className="ri-map-pin-line text-teal-600 mr-2"></i>
              沖繩縣石垣市真榮里
            </p>
          </div>
        </div>

      </div>
    </section>
  );
}
